export default __webpack_public_path__ + "static/Brandon-Medium-500-246edbf148fc28d21b142b06239a6d52.woff";